// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b6738707","205":"574fe3bf","374":"c04eefbc","403":"263a42ca","484":"1bef058b","508":"19343943","551":"f08f88f6","869":"d1c6690c","974":"2be7b50c"}[chunkId] + ".chunk.js";
};